
export default {
    name: 'room-stats',
    components: {
    },
    created() {

        let t = this;

        for (let i = 0; i < 12; i++) {
            t.list.month.push(i + 1);
        }

        for (let i = 0; i < 12; i++) {
            t.list.monthStats.push({
                rate: 0,
                days: 0,
                total_fee_billion: 0,
                items: []
            });
        }

        t.loadData();

        t.loadTasks();
    },
    mounted() {

        let t = this;

        t.initLineChart();

        t.list.color1 = [...t.colorPanel1];
        t.list.color2 = [...t.colorPanel2];
    },
    methods: {

        loadData() {
            let t = this;

            axios.get('room').then(res => {
                if (res.data.status == 1) {
                    let items = res.data.options.items;
                    items.forEach(item => {
                        item.monthDatas = [];
                        item.selected = false;
                        item.total_fee_million = 0;
                        item.rate = 0;
                        item.days = 0;

                        for (let i = 0; i < 12; i++) {
                            item.monthDatas.push({
                                'rate': 0,
                                'days': 0,
                                'total_fee_million': 0,
                            });
                        }
                    });
                    t.list.room = items;
                    t.dict.room = listToDict(t.list.room);

                    axios.get('room/occupancyRateStats').then(res => {
                        if (res.data.status == 1) {
                            let stats = res.data.options;
                            stats.yearly.forEach(item => {
                                let room = t.dict.room[item.room_id];
                                if (room) {
                                    room.rate = Number(item.occupancy_rate ? item.occupancy_rate.replace('%', '') : 0);
                                    room.days = item.occupied_days;
                                    room.total_fee_million = Math.round(item.total_fee / 10000);
                                }
                            });

                            for (const room_id in stats.monthly) {
                                let room = t.dict.room[room_id];
                                if (room) {
                                    let items = stats.monthly[room_id];
                                    items.forEach((item, i) => {
                                        let monthStats = t.list.monthStats[i];
                                        monthStats.items.push(item);
                                        room.monthDatas[i] = {
                                            rate: Number(item.occupancy_rate ? item.occupancy_rate.replace('%', '') : 0),
                                            days: item.occupied_days,
                                            total_fee_million: Math.round(item.total_fee / 10000),
                                        };

                                        room.monthDatas[i].price = Math.round(item.total_fee / room.monthDatas[i].days);
                                    });
                                }
                            }

                            t.list.monthStats.forEach(item => {
                                let totalFee = 0;
                                let totalDays = Number(item.items[0].total_days) * item.items.length;
                                let occupiedDays = 0;
                                item.items.forEach(item => {
                                    totalFee += Number(item.total_fee);
                                    occupiedDays += Number(item.occupied_days);
                                });
                                item.rate = Math.round(occupiedDays / totalDays * 100);
                                item.days = occupiedDays;
                                item.total_fee_billion = Math.round(totalFee / 10000 / 10000 * 100) / 100;
                            });

                            // stats.periods.forEach(item => {
                            //     t.list.dayStats.push({
                            //         rate: Number(item.occupancy_rate.replace('%', '')),
                            //         days: item.period_days,
                            //         total_fee_billion: Math.round(item.total_fee / 10000 / 10000 * 100) / 100,
                            //     });
                            // });

                            t.list.room = t.list.room.sort((a, b) => {
                                return b.rate - a.rate;
                            });
                        }
                    });

                }
            });

        },

        loadTasks() {

            let t = this;

            axios.get('monitorTask').then(res => {
                if (res.data.status == 1) {
                    res.data.options.items.forEach(item => {
                        item.stats = {};
                        item.selected = false;
                        item.propertyList = [];
                        item.range = 1;
                    });
                    t.list.task = res.data.options.items;
                }
            });
        },

        minusRange(item) {
            let t = this;
            if (item.range <= 1)
                return;
            item.range--;
            if (window.timeout_loadPropertyList)
                clearTimeout(window.timeout_loadPropertyList);
            window.timeout_loadPropertyList = window.setTimeout(() => {
                window.timeout_loadPropertyList = null;
                t.loadPropertyList(item);
            }, 500);
        },

        addRange(item) {
            let t = this;
            if (item.range >= 7)
                return;
            item.range++;

            if (window.timeout_loadPropertyList)
                clearTimeout(window.timeout_loadPropertyList);
            window.timeout_loadPropertyList = window.setTimeout(() => {
                window.timeout_loadPropertyList = null;
                t.loadPropertyList(item);
            }, 500);
        },

        selectProperty(i, item) {

            let t = this;

            if (!item.selected && t.list.selectedTask[i].propertyList.filter(item => item.selected).length >= 6) {
                return;
            }

            item.selected = !item.selected;

            if (item.selected) {
                if (!item.bgColor) {
                    item.bgColor = t.list['color' + (i + 1)].shift();
                }
                if (!item.occupancy_rates) {
                    let p = {
                        start_date: t.startDate,
                        end_date: t.endDate,
                        people: 2,
                    };
                    axios.get('monitorTask/getPropertyOccupancyRate/' + item.id, { params: p }).then(res => {
                        if (res.data.status == 1) {
                            item.occupancy_rates = res.data.options.rates;
                            item.prices = res.data.options.prices;
                            t.initLineChart();
                        }
                    });
                }
                else {
                    t.initLineChart();
                }
            }
            else {
                t.list['color' + (i + 1)].push(item.bgColor);
                item.bgColor = '';
                t.initLineChart();
            }
        },

        initLineChart() {

            let t = this;

            let chartDom = document.getElementById('lineChart');
            let myChart = echarts.init(chartDom);
            let option;

            let series = [];

            myChart.clear();
            let minPrice = Infinity;
            let maxPrice = 0;

            let prices = [];

            function lightenHexColor(hex, percent = 50) {
                // 移除 #
                hex = hex.replace(/^#/, '');

                // 处理简写（如 #abc → #aabbcc）
                if (hex.length === 3) {
                    hex = hex.split('').map(c => c + c).join('');
                }

                // 解析 RGB
                const r = parseInt(hex.substring(0, 2), 16);
                const g = parseInt(hex.substring(2, 4), 16);
                const b = parseInt(hex.substring(4, 6), 16);

                // 与白色 (#FFFFFF) 混合：new = (1 - p) * color + p * white
                // percent 是混合白色的比例（0~100）
                const p = percent / 100;
                const newR = Math.round((1 - p) * r + p * 255);
                const newG = Math.round((1 - p) * g + p * 255);
                const newB = Math.round((1 - p) * b + p * 255);

                // 转回 hex
                return `#${((1 << 24) + (newR << 16) + (newG << 8) + newB).toString(16).slice(1).toUpperCase()}`;
            }

            if (t.list.selectedTask[0]) {
                t.list.selectedTask[0].propertyList.filter(item => item.selected).forEach(item => {
                    let arr = [];
                    item.occupancy_rates.forEach((v, i) => {
                        let price = Math.round(item.prices[i]);
                        arr.push({
                            'value': v,
                            'price':price
                        });
                        prices.push(price);
                    });
                    series.push({
                        name: t.shortText4(item.name, 12),
                        type: 'line',
                        smooth: true,
                        data: arr,
                        lineStyle: {
                            color: item.bgColor
                        },
                        itemStyle: {
                            color: item.bgColor
                        }
                    });
                    series.push({
                        yAxisIndex: 1,
                        name: t.shortText4(item.name, 12),
                        type: 'line',
                        smooth: true,
                        data: item.prices,
                        lineStyle: {
                            color: lightenHexColor(item.bgColor)
                        },
                        itemStyle: {
                            color: lightenHexColor(item.bgColor)
                        },
                        tooltip: {
                            show: false
                        }
                    });
                });
            }

            if (t.list.selectedTask[1]) {
                t.list.selectedTask[1].propertyList.filter(item => item.selected).forEach(item => {
                    let arr = [];
                    item.occupancy_rates.forEach((v, i) => {
                        let price = Math.round(item.prices[i]);
                        arr.push({
                            'value': v,
                            'price':price
                        });
                        prices.push(price);
                    });
                    series.push({
                        name: t.shortText4(item.name, 12),
                        type: 'line',
                        smooth: true,
                        data: arr,
                        lineStyle: {
                            color: item.bgColor
                        },
                        itemStyle: {
                            color: item.bgColor
                        }
                    });

                    series.push({
                        yAxisIndex: 1,
                        name: t.shortText4(item.name, 12),
                        type: 'line',
                        smooth: true,
                        data: item.prices,
                        lineStyle: {
                            color: lightenHexColor(item.bgColor)
                        },
                        itemStyle: {
                            color: lightenHexColor(item.bgColor)
                        }
                    })
                });
            }

            t.list.room.filter(item => item.selected).forEach(item => {
                let arr = [];
                let roomPrices = [];
                item.monthDatas.forEach(item => {
                    arr.push({
                        'value': item.rate,
                        'price': item.price
                    });
                    roomPrices.push(item.price);
                    prices.push(item.price);
                });
                series.push({
                    name: item.name,
                    type: 'line',
                    smooth: true,
                    data: arr,
                    lineStyle: {
                        color: '#000'
                    },
                    itemStyle: {
                        color: '#000'
                    }
                });
                series.push({
                    yAxisIndex: 1,
                    name: item.name,
                    type: 'line',
                    smooth: true,
                    data: roomPrices,
                    lineStyle: {
                        color: '#808080'
                    },
                    itemStyle: {
                        color: '#808080'
                    }
                });

            });

            minPrice = Math.min(...prices);
            maxPrice = Math.max(...prices);

            option = {
                tooltip: {
                    trigger: 'axis',
                    position: function (point, params, dom, rect, size) {
                        return [point[0], point[1] + 20];
                    },
                    formatter: function (params) {

                        if (!Array.isArray(params)) params = [params]; // 兼容 'item' 模式

                        const dataIndex = params[0].dataIndex; // 👈 安全拿到 x 轴序号
                        window.currentDataIndex = dataIndex; // 临时全局变量示例

                        let header = '';
                        if (params[0].axisValueLabel || params[0].name) {
                            header = params[0].axisValueLabel || params[0].name + '<br/>';
                        }

                        const items = params.map(p => {
                            if (typeof p.data == 'number') {
                                return;
                            }
                            let displayValue = p.value;
                            if (typeof p.value === 'number') {
                                displayValue = '<div>稼働率 <b>' + p.value.toFixed(2) + '%</b> ' + '<br>平均单价 <b>' + Math.round(p.data.price) + '円</b></div>';
                            }

                            return '<div style="display:flex;gap:60px;align-items:center;"><div>' + p.marker + p.seriesName + '</div> ' + displayValue + '</div>';
                        }).join('<br/>');

                        return header + '<br>' + items;
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    axisLabel: {
                        fontSize: 10
                    }
                },
                yAxis: [{
                    type: 'value',
                    min: 0,
                    max: 150,
                    axisLabel: {
                        fontSize: 10
                    },

                },
                {
                    type: 'value',
                    min: minPrice,
                    max: maxPrice,
                    axisLabel: {
                        fontSize: 10
                    },
                    splitLine: {
                        show: false
                    },
                    tooltip: {
                        show: false
                    }
                }
                ],
                series: series
            };

            option && myChart.setOption(option);

        },

        selectTask(item) {
            let t = this;
            if (!t.list.selectedTask.includes(item)) {
                t.list.selectedTask.push(item);
                if (item.propertyList.length == 0) {
                    t.loadPropertyList(item);
                }
                if (!item.stats.loaded) {

                    let p = {
                        start_date: t.startDate,
                        end_date: t.endDate,
                        distance: item.range * 1000,
                        people: 2,
                    };

                    axios.get('monitorTask/getStats/' + item.id, { params: p }).then(res => {
                        if (res.data.status == 1) {
                            item.stats = res.data.options.stats;
                            item.stats.loaded = true;
                        }
                    });

                }
            }
            if (t.list.selectedTask.length > 2) {
                let task = t.list.selectedTask.shift();
                task.selected = false;
            }
        },

        loadPropertyList(task) {

            let t = this;

            let p = t._buildReqPrams(task);

            p.pageSize = 40;
            p.page = 1;

            axios.get('monitorTask/getPropertyList/' + task.id, { params: p }).then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;
                    arr.forEach(item => {
                        item.selected = false;
                        item.bgColor = '';
                    });
                    task.propertyList = arr;
                }
            });

        },

        _buildReqPrams(task) {

            let t = this;

            // let f = JSON.parse(JSON.stringify(t.filter));

            // if (f.price[1] >= 110) {
            //     f.price = [f.price[0] * 1000, 'MAX'];
            // }
            // else {
            //     f.price[0] = f.price[0] * 1000;
            //     f.price[1] = f.price[1] * 1000;
            // } 

            // if (f.reviews[1] >= 1100)
            //     f.reviews = [f.reviews[0], 'MAX']

            // if (f.people[1] >= 21)
            //     f.people = [f.people[0], 'MAX']

            let p = {
                '_filter': t.filter,
                'start_date': t.startDate,
                'end_date': t.endDate,
                'distance': task.range * 1000,
                'people': 2,
            };

            p._order = 'occupancy_rate-DESC';

            return p;

        },

        gridBgColor(type, percent) {

            function blendTransparentColor(hex, alpha = 0.65) {

                const backgroundRGB = [255, 255, 255];

                const cleaned = hex.replace(/^#/, '');

                // 分割成两两一组
                const fr = parseInt(cleaned.slice(0, 2), 16); // FC → 252
                const fg = parseInt(cleaned.slice(2, 4), 16); // A0 → 160
                const fb = parseInt(cleaned.slice(4, 6), 16); // 00 → 0
                const [br, bg, bb] = backgroundRGB;

                const r = Math.round(alpha * fr + (1 - alpha) * br);
                const g = Math.round(alpha * fg + (1 - alpha) * bg);
                const b = Math.round(alpha * fb + (1 - alpha) * bb);

                return `rgb(${r}, ${g}, ${b})`;
            }

            let colors = {
                1: '#98CDC7',
                2: '#7AA8B8',
                3: '#D88384',
            };

            if (percent == 0) {
                return 'transparent';
            }

            return blendTransparentColor(colors[type], percent / 100);
        },

        getRandomColorForWhiteBg() {
            // 定义HSV范围
            const minSaturation = 0.4;  // 最小饱和度，避免生成太灰的颜色
            const maxSaturation = 1.0;  // 最大饱和度
            const maxValue = 0.7;   // 最大亮度，限制为0.7，避免过亮接近白色
            const minValue = 0.2;   // 最小亮度，避免过暗接近黑色（可选，根据需要调整）

            // 随机生成 H, S, V
            const h = Math.floor(Math.random() * 360); // 色调: 0 - 359
            const s = minSaturation + Math.random() * (maxSaturation - minSaturation); // 饱和度: minSaturation - maxSaturation
            const v = minValue + Math.random() * (maxValue - minValue); // 亮度: minValue - maxValue

            // 将HSV转换为RGB
            let r, g, b;
            const c = v * s; // Chroma
            const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
            const m = v - c;

            if (0 <= h && h < 60) {
                r = c; g = x; b = 0;
            } else if (60 <= h && h < 120) {
                r = x; g = c; b = 0;
            } else if (120 <= h && h < 180) {
                r = 0; g = c; b = x;
            } else if (180 <= h && h < 240) {
                r = 0; g = x; b = c;
            } else if (240 <= h && h < 300) {
                r = x; g = 0; b = c;
            } else if (300 <= h && h < 360) {
                r = c; g = 0; b = x;
            }

            r = Math.round((r + m) * 255);
            g = Math.round((g + m) * 255);
            b = Math.round((b + m) * 255);

            // 转换为16进制
            const toHex = (n) => n.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        },

        sort(skip) {
            let t = this;

            if (!skip) {

                if (t.rateSort == 'desc') {
                    t.rateSort = 'asc';
                }
                else {
                    t.rateSort = 'desc';
                }
            }

            if (t.rateSort == 'asc') {
                t.list.room = t.list.room.sort((a, b) => {
                    return a[t.sortField] - b[t.sortField];
                });
            }
            else {
                t.list.room = t.list.room.sort((a, b) => {
                    return b[t.sortField] - a[t.sortField];
                });
            }
        },

        clearSelectedTasks() {
            let t = this;
            t.list.selectedTask.forEach(item => {
                item.propertyList.forEach(p => {
                    p.selected = false;
                    p.bgColor = '';
                });
            });
            t.list.selectedTask.clear();
            t.list.color1 = [...t.colorPanel1];
            t.list.color2 = [...t.colorPanel2];
            t.initLineChart();
            t.$forceUpdate();
        },

    },
    data() {
        return {
            startDate: "2026-01-01",
            endDate: "2026-12-01",
            dict: {
                room: {}
            },
            list: {
                room: [],
                month: [],
                dayStats: [
                ],
                monthStats: [
                ],
                task: [],
                selectedTask: [],
                color1: [
                ],
                color2: [
                ],
            },
            colorPanel1: [
                '#E70012',
                '#F29902',
                '#FDF002',
                '#90C31F',
                '#009B45',
                '#02A098',
            ],
            colorPanel2: [
                '#02A0ED',
                '#0167BA',
                '#1E228A',
                '#930884',
                '#E3017E',
                '#E60052'
            ],
            rateSort: 'desc',
            sortField: 'rate',

            filter: {
                "room": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 0],
                "type": ["house", "apartment", "cottage", "bungalow", "villa", "holiday village", "chalet", "hotel", "other"],
                "reviews": [0, "MAX"],
                "rating": [0, 5],
                "people": [2, "MAX"],
                "price": [1000, "MAX"],
                "occupancy_rate": [0, 100]
            }
        };
    },
    computed: {
    }
};
